import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { ROUTES } from 'constants/routes';

import MyTurns from './screens/MyTurns';
import NewTurn from './screens/NewTurn';
import styles from './styles.module.scss';

const TurnsContainer = () => (
  <div className={styles.turnsContainer}>
    <Switch>
      <Route exact path={ROUTES.MY_TURNS} component={MyTurns} />
      <Route exact path={ROUTES.NEW_TURN} component={NewTurn} />
    </Switch>
  </div>
);

export default TurnsContainer;
